
import TranslateComponent from "./translate.vue";
import SelectLanguage from "./select-language.vue";

export const Translate = {
	install(Vue:any, options:any){
		Vue.component("translate", TranslateComponent);
		Vue.component("select-language", SelectLanguage);
	}
};

export { useTranslate } from "./useTranslate";